import {createFeatureSelector, createSelector} from "@ngrx/store";
import {IHostingVisitsState} from "../reducers/hosting-visits.reducer";
import {DbStoreState} from "../reducers";
import {TypeUtils} from "../../shared/utils/type-utils";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getHostingVisitsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.hostingVisits);

export const getHostingVisits = createSelector(getHostingVisitsState,
  (state: IHostingVisitsState) => state.hostingVisits ? state.hostingVisits.entities : null
);

export const getHostingVisitsByWebsiteByDate = (websiteId: number) => createSelector(getHostingVisitsState,
  (state: IHostingVisitsState) => {
    if (state.entities[websiteId] && !TypeUtils.isEmpty(state.entities[websiteId].entities)) {
      const data = state.entities[websiteId].entities;
      const visitsData = {
        sum: data.sum ? data.sum : 0,
        data: data.data ? data.data : [],
        start_data: data.start_data ? data.start_data : null,
        end_data: data.end_data ? data.end_data : null
      };
      return visitsData;
    }
    return null
  }
);

export const getHostingVisitsByWebsiteByDateMap = (websiteId: number) => createSelector(getHostingVisitsState,
  (state: IHostingVisitsState) => state.entities[websiteId]
);

export const getHostingVisitsByWebsiteByDateLoading  = (websiteId: number) => createSelector(getHostingVisitsState,
  (state: IHostingVisitsState) =>
    state.entities && state.entities[websiteId].loading
);

export const getHostingVisitsByWebsiteByDateLoaded = (websiteId: number) => createSelector(getHostingVisitsState,
  (state: IHostingVisitsState) =>
    state.entities && state.entities[websiteId] && state.entities[websiteId].loaded
);
